import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import { ChevronDownIcon } from '@anyx/shared-icons';

export interface ComboboxChevronProps extends ComponentPropsWithoutRef<'span'> {
  iconClassName?: string;
}

export const ComboboxChevron = ({ className, iconClassName, ...rest }: ComboboxChevronProps) => {
  return (
    <span
      {...rest}
      className={classNames('inline-flex items-center justify-center', className)}
      aria-hidden
    >
      <ChevronDownIcon className={classNames('text-gray-5 h-4 w-4', iconClassName)} />
    </span>
  );
};
